const initTooltips = (selector, options = {}) => {
  $(selector).tooltip(options);
};

export default initTooltips;
